import type { TodoTask } from '@/types/todo';

type ApiTodoTask = TodoTask & {
  notes_markdown?: string | null;
};

/**
 * Normalizes task data coming from the API. The backend historically sent
 * `notes_markdown` while newer responses use `notesMarkdown`, so this helper
 * ensures the camelCase field is always populated for the editor.
 */
export function normalizeTodoTask(task: ApiTodoTask): TodoTask {
  const legacyNotes =
    typeof task.notes_markdown === 'string' ? task.notes_markdown : undefined;
  const notesMarkdown =
    typeof task.notesMarkdown === 'string' && task.notesMarkdown.length > 0
      ? task.notesMarkdown
      : legacyNotes ?? '';

  if (notesMarkdown === task.notesMarkdown) {
    return task;
  }

  return {
    ...task,
    notesMarkdown,
  };
}
